import React, {useContext} from "react";
import CountryButton from "../Components/CountryButton";
import CountryWindow from "../Components/CountryWindow";
import MoreInfoSection from "../Components/MoreInfoSection";
import GoBack from "../Components/GoBack";
import Button from "../Components/Button";
import MapChart from "../Components/MapChart";
import {DataContext} from "../Context/DataContext";
import countriesCodes from "../Services/Constants/countriesCodes";

export default function SuggestedMarkets({topCountries}) {
	const {activeCountries, setShowedScreen} = useContext(DataContext);

	// Get the ISO codes of the top countries
	let topCodes = [];
	topCountries.forEach((country) => {
		if (country.name === "Unión Europea") topCodes = [...topCodes, ...countriesCodes[country.name][1]];
		else topCodes.push(countriesCodes[country.name][1]);
	});

	// Go to previous page
	const goToSelectVariables = () => {
		setShowedScreen(1);
		window.scrollTo(0, 0);
	};

	return (
		<div className='page-content'>
			<div className='go-back-and-title'>
				<GoBack action={goToSelectVariables} />
				<h1 className='title'>MERCADOS SUGERIDOS</h1>
			</div>
			<div className='dividing-line'></div>
			<p className='paragraph'>
				Nos hemos basado en métricas clave de las categorías que has escogido para calcular qué mercados te ofrecen las mejores oportunidades de crecimiento. Los 3 países con mejor afinidad a
				tus variables escogidas los puedes ver a continuación. Para ver más información sobre estos países, haz clic en la tarjeta de cada uno.
			</p>
			<div className='countries-buttons'>
				{topCountries.map((c) => (
					<CountryButton position={c.position} name={c.name} flag={c.flag} />
				))}
			</div>
			<div className='map-container' style={{display: activeCountries[0] || activeCountries[1] || activeCountries[2] || window.innerWidth > 850 ? "block" : "none"}}>
				<MapChart topCodes={topCodes} />
				<div className='country-window-container' style={{display: activeCountries[0] || activeCountries[1] || activeCountries[2] ? "flex" : "none"}}>
					{activeCountries[0] ? <CountryWindow position={topCountries[0].position} name={topCountries[0].name} flag={topCountries[0].flag} variables={topCountries[0].variables} /> : <></>}
					{activeCountries[1] ? <CountryWindow position={topCountries[1].position} name={topCountries[1].name} flag={topCountries[1].flag} variables={topCountries[1].variables} /> : <></>}
					{activeCountries[2] ? <CountryWindow position={topCountries[2].position} name={topCountries[2].name} flag={topCountries[2].flag} variables={topCountries[2].variables} /> : <></>}
				</div>
			</div>
			<MoreInfoSection />
			<Button content={"Volver a calcular mercados de destino"} type={"default"} size={"big"} action={goToSelectVariables} />
		</div>
	);
}
